import { render, staticRenderFns } from "./SplitPanelA.vue?vue&type=template&id=045cdf58&scoped=true&"
import script from "./SplitPanelA.vue?vue&type=script&lang=js&"
export * from "./SplitPanelA.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "045cdf58",
  null
  
)

export default component.exports